export default {
    getMonthShortName(monthNo) {
        const date = new Date();
        date.setMonth(monthNo-1);
        return date.toLocaleString('en-US', { month: 'short' });
    },
    getYearShortName(year) {
        return year.toString().slice(-2);
    },
}